<template>
  <donut-chart101-template
    :board-ids="[965]"
    :data-type="dataType"
    :graph-id="101"
    :depth="depth"
    date-field="$.body.stdInfo.date"
    :count-fields="['body.위험성평가표[*].예상재해형태_내용']"
    :is-move-detail="false"
    title="위험성평가 현황"
    unit="건"/>
</template>
<script>
/* eslint-disable brace-style */

import DonutChart101Template from "@/views/graph/DonutChart101Template.vue";

export default {
  name: 'DonutChart101',
  components: {DonutChart101Template},
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
    dataType() {
      if (!this.projectId) {
        return 'project';
      }
      // if (this.getLevel === 1) {
      //   return 'countFields';
      // } else {
      //   return 'company';
      // }
      return 'countFields';
    },
    depth() {
      switch (this.getLevel) {
      case 1:
      case 2:
        return 1;
      case 3:
        return 1;
      case 4:
        return 0;
      default:
        return 1;
      }
    }
  }
}
</script>

<style scoped>

</style>
